var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M11.275 4.61a.625.625 0 1 0-.883.883l3.85 3.85H3.958a.625.625 0 1 0 0 1.25h10.267l-3.84 3.915a.628.628 0 0 0 .892.883l4.683-4.683a1 1 0 0 0 0-1.414z"
  })));
};
export default SvgArrowRight;